/** Pinned MJ Action IDs (metadata/actions/oep-actions.json) — GraphQLActionClient.RunAction takes an ID. */
export const OEP_ACTION_IDS = {
    RunGate: '0E900000-0000-4000-9000-000000000401',
    PreviewSend: '0E900000-0000-4000-9000-000000000402',
    SendReminders: '0E900000-0000-4000-9000-000000000403',
    SendTrainingMaterials: '0E900000-0000-4000-9000-000000000404',
    ReopenSlate: '0E900000-0000-4000-9000-000000000406',
} as const;

export type OEPActionKey = keyof typeof OEP_ACTION_IDS;

/** MJ Action names (Action.Name = DriverClass = the @RegisterClass key in apps/MJAPI/src/oep/actions.ts). */
export const OEP_ACTION_NAMES: Readonly<Record<OEPActionKey, string>> = {
    RunGate: 'OEP Run Gate',
    PreviewSend: 'OEP Preview Send',
    SendReminders: 'OEP Send Reminders',
    SendTrainingMaterials: 'OEP Send Training Materials',
    ReopenSlate: 'OEP Reopen Slate',
};

/** Every result code an OEP action returns (apps/MJAPI/src/oep/actions.ts; per-action subsets are its MJ: Action Result Codes rows). */
export const OEP_ACTION_RESULT_CODES = [
    'SUCCESS', 'NOT_STAFF', 'GATE_ORDER', 'GATE_BUSY', 'BAD_GATE', 'NOTHING_TO_REMIND', 'BAD_SELECTION', 'NO_ACTIVE_SEASON', 'SEASON_CONFIG', 'FAILED',
] as const;
export type OEPActionResultCode = (typeof OEP_ACTION_RESULT_CODES)[number];

export function IsOEPActionResultCode(value: string): value is OEPActionResultCode {
    return (OEP_ACTION_RESULT_CODES as readonly string[]).includes(value);
}
